import { gql } from '@apollo/client';

export const updateCaseMutation = gql`
  mutation ($pk_columns: cases_pk_columns_input!, $set: cases_set_input!, $caseId: uuid!) {
    update_cases_by_pk(pk_columns: $pk_columns, _set: $set) {
      id
    }
    update_pots(where: { case_id: { _eq: $caseId } }, _set: { status: RESULTS_ADDED }) {
      affected_rows
    }
  }
`;
